"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const CollectionImage = (0, react_1.forwardRef)(({ alt, className, src, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsx)("img", { ref: ref, className: (0, uswds_react_utils_1.createClassString)('usa-collection__img', className), src: src, alt: alt, ...props }));
});
exports.default = CollectionImage;
